//import sceneImage from "@/assets/browsergame/scene1.png";

export class Scene {
  constructor(ctx, relation, prohibited) {
    this.relation = relation;
    this.width = 1920 * relation;
    this.height = 1080 * relation;
    this.ctx = ctx;
    //    this.title = title;
    this.image = this.getImage();
    this.prohibited = prohibited;
    this.prohibitedAreas = [];
    this.setBackground();
    this.drawAssets();
    this.drawProhibitedAreas();
  }
  resize() {
    this.drawProhibitedAreas();
    this.draw();
  }
  setBackground() {
    const self = this;
    this.background = new Image();
    this.background.src = this.image;
    this.background.onload = () => {
      self.draw();
    };
  }
  draw() {
    this.ctx.drawImage(this.background, 0, 0, this.width, this.height);
  }
  getImage() {
    return require("@/assets/browsergame/scene1.png");
  }
  drawAssets() {}
  animate() {}
  drawProhibitedAreas() {
    // Muss beim resize neu aufgerufen werden
    let i = 0;
    for (let [...area] of this.prohibited) {
      //get through each prohibited area
      this.prohibitedAreas[i] = new Path2D();
      let first = area.shift(); //get first point
      this.prohibitedAreas[i].moveTo(this.rel(first.x), this.rel(first.y));

      //this.ctx.beginPath();
      //this.ctx.moveTo(this.rel(first.x), this.rel(first.y)); //draw first point
      for (let point of area) {
        //draw rest of the polygon
        this.prohibitedAreas[i].lineTo(this.rel(point.x), this.rel(point.y)); //draw points
        //this.ctx.lineTo(this.rel(point.x),this.rel(point.y)); //draw points
      }
      this.prohibitedAreas[i].closePath(); //finsish polygon
    }
  }
  isProhibited(x, y) {
    for (let path of this.prohibitedAreas) {
      //get through each prohibited area
      if (this.ctx.isPointInPath(path, x, y)) {
        //check if clicked point is inside prohibited area
        return true;
      }
    }
  }
  rel(val) {
    return Math.ceil(this.relation * val);
  }
  get nogo() {
    return this.prohibitedAreas;
  }
}
